import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { localStorageMessageKey, localStorageUrlRedirect } from '../configurations/application.config';
import { APPLICATION_ACTIONS } from '../store/actions/application.actions';
import { RouterService } from './router.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  constructor(
    private readonly store: Store,
    private readonly window: Window,
    private readonly routerService: RouterService,
  ) {
    this.initAppMessageListener();
  }

  sendAppMessage(message: string | number): void {
    this.window.localStorage.removeItem(localStorageMessageKey);
    this.window.localStorage.setItem(localStorageMessageKey, String(message));
  }

  saveActiveUrlToStorage(): void {
    const urlToStartNextSession: string = this.routerService.getUrlForStartNextSession();
    if (urlToStartNextSession.length) {
      this.window.localStorage.setItem(localStorageUrlRedirect, urlToStartNextSession);
    }
  }

  getUrlFromStorage(): string | null {
    return this.window.localStorage.getItem(localStorageUrlRedirect);
  }

  removeUrlFromStorage(): void {
    this.window.localStorage.removeItem(localStorageUrlRedirect);
  }

  private initAppMessageListener(): void {
    this.window.addEventListener('storage', this.storageEventHandler.bind(this));
  }

  private storageEventHandler(event: StorageEvent): void {
    if (event?.key === localStorageMessageKey && event.newValue) {
      this.store.dispatch(APPLICATION_ACTIONS.messageReceived({ message: event.newValue }));
    }
  }
}
